const func = ($target) => {
	if($('.gallery-content .gallery-top .swiper-slide').length > 1) {
		window.loader.key("swiper", function () {
			var $thumbs = $target.find(".gallery-thumbs"),
				$top = $target.find(".gallery-top"),
				$imageCount = $target.data('image-count');

			var thumbs = new Swiper($thumbs, {
				slidesPerView: $imageCount ? $imageCount : 4,
				spaceBetween: 15,
				allowTouchMove: false,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
			});

			var top = new Swiper($top, {
				slidesPerView: 1,
				spaceBetween: 0,
				effect: "slide",
				updateOnImagesReady: true,
				navigation: {
					nextEl: $target.find(".swiper-button-next"),
					prevEl: $target.find(".swiper-button-prev"),
				},
				thumbs: {
					swiper: thumbs,
				},
				breakpointsInverse: true,
				breakpoints: {
					768: {
						// md (and up) config here
					},
				},
				on: {
					imagesReady: function () {
						//fade gallery in when main/big images ready
						$target.find(".gallery-content").addClass("show");
						$target.removeClass("preload");
					},
				},
			});
		});

	} else {
		$target.find(".gallery-content").addClass("show");
		$target.removeClass("preload");
	}
};

export default func;
